import { ReportLog } from "./ReportLog";
import SaapApi from "./SaapApi";

class Report {
  // Response Type
  static RESPONSE_TOKEN = 1;
  static RESPONSE_COMMAND = 2;
  static RESPONSE_REPORT = 3;
  static RESPONSE_ERROR = 4;
  static RESPONSE_KEEP_ALIVE = 5;
  static RESPONSE_CONFIG = 6;

  constructor(context, token, actionOrData, data = null) {
    this.log = new ReportLog(token);
    this.respMap = new Map([
      // Token response data 1
      [0xb0, "TknInit"],
      [0xb1, "TknSigVerified"],
      [0xb2, "TknSigFail"],

      // Command response data 2
      [0xa1, "LkrUnlocked"],
      [0xa2, "LkrLocked"],
      [0xa3, "LkrError"],
      [0xa4, "LkrTmpUnlocked"],

      // Report response data 3
      [0x01, "BatStatus"],
      [0x02, "EcuTemp"], // part of batt status
      [0x03, "EcuFaultCodes"], // not implemented
      [0x04, "AllLockStatus"],
      [0x05, "ARReceived"],
      [0x06, "ARReceivedAll"], // not processing

      // Error response data 4
      // RETRY
      [0xc0, "TknErrInvldLen"],
      [0xc1, "ErrInvldSDKLen"],
      [0xc2, "TknErrConnTmOut"],
      [0xc3, "TknErrInvldData"],
      [0xc4, "ErrJWTParseHdr"],
      [0xc5, "ErrJWTParsePld"],
      [0xc6, "ErrJWTParseDiag"],
      [0xc7, "InvldBLEChr"],
      [0xc8, "InvldDataSeq"],
      [0xc9, "B64DcdErr"],
      [0xca, "DecryptErr01"],

      // TOKENERROR
      [0xd0, "TknErrSigFail"],
      [0xd1, "TknErrInvldBxCd"],
      [0xd2, "TknErrInvldMcuCode"],
      [0xd3, "TknErrInvldCntr"],
      [0xd4, "DiagFlshSnvFail"],
      [0xd5, "DiagSnvWrtFail"],
      [0xd6, "BkngIdVrfFail"],
      [0xd7, "InvldSDKPkt"],
      [0xd8, "ApplNotSupprtd"],
      [0xd9, "InvldSDKCd"],
      [0xda, "TknTimExprd"],
      [0xdb, "CmdNotSupprtd"],
      [0xdc, "TknTypNotSupprtd"],
      [0xdd, "RptNotSupprtd"],

      // BOX ERROR
      [0xe0, "TknErrLowBatt"],
      [0xe1, "InvalidBxSt"],
      [0xe2, "UnLckErrHw"],

      [0xff, "TknErrNoErr"],
    ]);

    this.notification = SaapApi.NOTIF_NONE;

    if (data === null) {
      // Bluetooth error
      this.notification = SaapApi.NOTIF_BLUETOOTH_ERROR;
      this.log.add("bt", "BtErr", new TextEncoder().encode(actionOrData));
    } else {
      this.processResponse(context, token, actionOrData, data);
    }
  }

  processResponse = (context, token, action, dat) => {
    this.dataLength = 1; // Placeholder, update as necessary
    this.responseType = dat[0];
    this.responsePending = dat[1];
    this.handshakeCode = [dat[2], dat[3]];

    console.log("Report: Process response..", this.responseType);

    switch (this.responseType) {
      case Report.RESPONSE_TOKEN:
        console.log("RESPONSE_TOKEN");
        this.handleResponseToken(dat);
        break;
      case Report.RESPONSE_COMMAND:
        console.log("RESPONSE_COMMAND");
        this.handleResponseCommand(action, dat);
        break;
      case Report.RESPONSE_REPORT:
        console.log("RESPONSE_REPORT");
        this.handleResponseReport(dat);
        break;
      case Report.RESPONSE_ERROR:
        console.log("RESPONSE_ERROR");
        this.handleResponseError(dat);
        break;
      case Report.RESPONSE_CONFIG:
        console.log("RESPONSE_CONFIG");
        this.handleResponseConfig(dat);
        break;
      default:
        break;
    }
  };

  handleResponseToken = (dat) => {
    this.responseData = dat.slice(4, 4 + this.dataLength);
    const code = this.responseData[0];
    if (code === 0xb2) {
      this.notification = SaapApi.NOTIF_TOKEN_ERROR;
      this.log.add("tok", this.respMap.get(code), this.responseData);
    }
  };

  handleResponseCommand = (action, dat) => {
    this.responseData = dat.slice(4, 4 + this.dataLength);
    let code = this.responseData[0] & 0xff;

    if (code === 0xa1) this.notification = SaapApi.NOTIF_LOCK_UNLOCKED;
    else if (code === 0xa2) this.notification = SaapApi.NOTIF_LOCK_LOCKED;
    else if (code === 0xa3) this.notification = SaapApi.NOTIF_UNLOCK_ERROR;

    if (code === 0xa1 && action === SaapApi.LOCKER_ACTION_TEMP_UNLOCK) {
      code = 0xa4;
    }

    if ([0xa1, 0xa2, 0xa3, 0xa4].includes(code)) {
      this.log.add("cmd", this.respMap.get(code), this.responseData);
    }
  };

  handleResponseReport = (dat) => {
    this.notification = SaapApi.NOTIF_NONE;
    this.dataLength = 12;
    this.responseData = dat.slice(4, 4 + this.dataLength);

    const code = this.responseData[1] & 0xff;
    this.log.add("rep", this.respMap.get(code), this.responseData);
  };

  handleResponseError = (dat) => {
    const retryCodes = [0xc3, 0xc4, 0xc5, 0xc6, 0xc9, 0xca, 0xe2];
    this.dataLength = 12;
    this.responseData = dat.slice(4, 4 + this.dataLength);

    const code = this.responseData[0] & 0xff;
    if (retryCodes.includes(code)) {
      this.notification = SaapApi.NOTIF_RETRY;
    } else if (code >= 0xd0 && code <= 0xdf) {
      this.notification = SaapApi.NOTIF_TOKEN_ERROR;
    } else if (code === 0xe1) {
      this.notification = SaapApi.NOTIF_BOX_ERROR;
    } else if (code === 0xe0) {
      this.notification = SaapApi.NOTIF_LOW_BATT;
    } else {
      this.notification = SaapApi.NOTIF_RETRY;
    }
    this.log.add("err", this.respMap.get(code), this.responseData);
  };

  handleResponseConfig = (dat) => {
    this.responseData = dat.slice(4, 4 + this.dataLength);
    const code = this.responseData[0];
    this.notification = SaapApi.NOTIF_CONFIG;
    this.log.add("cfg", this.respMap.get(code), this.responseData);
  };
}

export default Report;
